import Typography from 'typography'
import oceanBeachTheme from 'typography-theme-ocean-beach'
import CodePlugin from 'typography-plugin-code'

oceanBeachTheme.overrideThemeStyles = ({ rhythm, scale }) => ({
  'tt,code': {
    background: '#f5f2f0',
    fontFamily: `Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace`
  },

  'a.anchor': {
    backgroundImage: 'none'
  },
  blockquote: {
    ...scale(0)
  }
})
oceanBeachTheme.baseFontSize = '16px'
oceanBeachTheme.baseLineHeight = '1.5'
oceanBeachTheme.headerFontFamily = ['Fira Sans', 'sans-serif']
oceanBeachTheme.bodyFontFamily = ['Fira Sans', 'sans-serif']
oceanBeachTheme.googleFonts = []
oceanBeachTheme.plugins = [new CodePlugin()]

const typography = new Typography(oceanBeachTheme)

export default typography



// WEBPACK FOOTER //
// ./src/utils/typography.js